import { Heading } from '@cinch-labs/design-system'
import { Guard, valueIsPresent } from '@cinch-labs/shared-util'
import {
  LandingHero as TLandingHero,
  storyblokEditable,
} from '@cinch-nx/data-storyblok'
import './landing-hero.module.css'
import { Wrapper } from '@cinch-nx/shared-ui'
import cx from 'classnames'
import Image from 'next/legacy/image'
import { StoryblokRenderer } from '../../../storyblok-renderer/storyblok-renderer'
import { storyblokComponents } from '../../../storyblok/storyblok-renderer-map'
import {
  AppStoreButtons,
  getWrapperClassName,
  useAppStore,
} from '../generic-hero'
import styles from './landing-hero.module.css'

export const LandingHero: React.FC<TLandingHero> = (blok) => {
  const { heading, image, logo, ctaButton } = blok
  Guard.ensure([
    valueIsPresent(heading, 'LandingHero heading'),
    valueIsPresent(image?.filename, 'LandingHero image'),
    valueIsPresent(logo?.filename, 'LandingHero logo'),
    valueIsPresent(ctaButton, 'LandingHero CTA button'),
  ])

  const { isAppRoute, handleAppStoreClick } = useAppStore()

  const getImageWrapperClassName = () =>
    cx(styles.imageWrapper, {
      [styles.appImageWrapper]: isAppRoute,
    })

  const getHeroContentClassName = () =>
    cx(styles.heroContent, {
      [styles.appHeroContent]: isAppRoute,
    })

  const getTitleClassName = () =>
    cx(styles.title, {
      [styles.appTitle]: isAppRoute,
    })

  return (
    <Wrapper
      {...storyblokEditable(blok)}
      isSlim
      className={{
        inner: getWrapperClassName(!!image?.filename, isAppRoute),
      }}
    >
      <div className={getImageWrapperClassName()}>
        <Image
          src={image.filename}
          alt={image.alt ?? undefined}
          priority
          layout="fill"
          objectFit="contain"
        />
      </div>
      <div className={getHeroContentClassName()}>
        <div className={styles.logo}>
          <Image
            src={logo.filename}
            alt={logo?.alt ?? undefined}
            priority
            quality={100}
            width={260}
            height={32}
          />
        </div>
        <Heading element="h1" className={getTitleClassName()}>
          {heading}
        </Heading>
        <div className={styles.ctaButton}>
          <StoryblokRenderer
            block={ctaButton}
            components={storyblokComponents}
          />
        </div>
        {isAppRoute && <AppStoreButtons onButtonClick={handleAppStoreClick} />}
      </div>
    </Wrapper>
  )
}
